<template>
    <div class="columns is-centered">
        <div class="column is-6">
            <form @submit.prevent="submit">
                <h4 class="title is-4">
                    Activate
                </h4>

                <p class="subtitle">
                    Please set a strong portal password at least {{ $minPasswordLength }} characters long,
                    including letters, numbers &amp; symbols.
                </p>

                <hr class="mb-5" />

                <FormNotification />

                <SavingNotification>Sending...</SavingNotification>

                <div class="columns">
                    <div class="column">
                        <b-field label="Veco™ Username">
                            <b-input
                                v-model="Username"
                                v-validate="{ required: true }"
                                type="text"
                                name="Username"
                            />
                        </b-field>
                    </div>

                    <div class="column">
                        <b-field label="Veco™ Password">
                            <b-input
                                v-model="Password"
                                v-validate="{ required: true }"
                                type="password"
                                name="Password"
                                password-reveal
                            />
                        </b-field>
                    </div>
                </div>

                <b-field label="Veco™ Email">
                    <b-input
                        v-model="Email"
                        v-validate="{ required: true, email: true }"
                        type="email"
                        name="Email"
                    />
                </b-field>

                <hr />

                <b-field label="Portal Password">
                    <b-input
                        ref="password"
                        v-model="PortalPassword"
                        v-validate="{ required: true, min: $minPasswordLength }"
                        type="password"
                        name="PortalPassword"
                        data-vv-as="Portal Password"
                        password-reveal
                    />
                </b-field>

                <b-field label="Confirm Portal Password">
                    <b-input
                        v-model="PortalPasswordConfirmation"
                        v-validate="{ required: true, min: $minPasswordLength, confirmed: 'password' }"
                        type="password"
                        name="PortalPasswordConfirmation"
                        data-vv-as="Portal Password Confirmation"
                        password-reveal
                    />
                </b-field>

                <b-button
                    type="is-info"
                    tag="button"
                    :disabled="isSending"
                    native-type="submit"
                >
                    Submit
                </b-button>
            </form>
        </div>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Form from '../../mixins/form.js';

export default {
    mixins: [
        Form,
    ],

    computed: {
        ...mapFields('staff', [
            'staff.Username',
            'staff.Email',
            'staff.Password',
            'staff.PortalPassword',
            'staff.PortalPasswordConfirmation',
        ]),
    },

    methods: {
        submit() {
            this.validate()
            .then((result) => {
                if (! result) {
                    return;
                }

                this.$store.dispatch('staff/activate', this.$route.params.token)
                .then((response) => {
                    this.statusMessage = response.data.message;
                    this.statusType = 'success';
                })
                .catch((error) => {
                    this.parseServerErrors(error);
                })
                .then(() => {
                    this.isSending = false;
                });
            });
        },
    },
};
</script>
